import React from "react";
import "./therapist-mobile-card.scss";
import Avatar from "src/components/base/Avatar/Avatar";
import { Typography } from "src/latest/src/components";
import AvailableSlots from "../AvailableSlots/AvailableSlots";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownLong } from "@fortawesome/free-solid-svg-icons";
import ClinicianMobileDetails from "src/containers/ClinitianAvailability/ClinicianMobileDetails";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import moment from "moment";
import GroupIcon from "src/assets/icons/GroupIcon.svg";
import { Spinner } from "react-bootstrap";

type Props = {
    therapistInfo: Object,
    selectedFilters: Object,
    bookAppointmentSlot: Function,
    statusLoading: boolean,
    statusLoadingElement: any,
    moreVisible: Array,
    index: number,
    cardExpand: number,
    handleAvailability: Function,
    expandAvailability: Function,
    profileRedirection: Function,
    practiceTimeZone: string,
    handleLaterSlot: Function,
};

function TherapistMobileCard({
    therapistInfo,
    selectedFilters,
    bookAppointmentSlot,
    statusLoading,
    statusLoadingElement,
    moreVisible,
    index,
    cardExpand,
    handleAvailability,
    expandAvailability,
    profileRedirection,
    practiceTimeZone,
    handleLaterSlot,
}: Props) {
    return (
        <div className="mobile-card-container">
            <div className="d-flex card-header-container">
                <div
                    onClick={() =>
                        profileRedirection(therapistInfo?.therapist_id, therapistInfo?.slugify_name)
                    }
                >
                    <Avatar
                        photoUrl={therapistInfo?.profile_picture}
                        fullName={therapistInfo?.therapist_name}
                        size="60px"
                    />
                </div>
                <div>
                    <div className="header-text">
                        <div
                            onClick={() =>
                                profileRedirection(therapistInfo?.therapist_id, therapistInfo?.slugify_name)
                            }
                        >
                            <Typography
                                weight="bold"
                                variant="size-20"
                                color="color-2"
                                className="therapist-name"
                            >
                                {" "}
                                {therapistInfo?.therapist_name?.length > 21
                                    ? `${therapistInfo.therapist_name?.substring(
                                        0,
                                        18
                                    )}...`
                                    : therapistInfo?.therapist_name}
                            </Typography>
                        </div>
                        <Typography
                            weight="bold"
                            variant="size-12"
                            color="color-28"
                        >
                            {" "}
                            {therapistInfo?.therapist_credentials}
                        </Typography>
                        {therapistInfo?.location_info && (
                        <div className="geolocation_distance d-flex mt-1">
                            <div>
                                <Typography className="fw-semibold location_info" color="color-4" variant="size-14">
                                    {therapistInfo?.location_info}
                                </Typography>
                            </div>
                            <div>
                           {therapistInfo?.distance !== null &&
                            therapistInfo?.distance !== undefined && (
                            <img
                             className="location-icon mb-2 ms-1"
                             src={GroupIcon}
                             alt="GroupIcon"
                              />
                              )}
                            </div>
                        </div>
                    )}
                        <div>
                            <Typography
                                weight="bold"
                                variant="size-12"
                                color="color-2"
                                component="div"
                            >
                                <ClinicianMobileDetails
                                    therapistInfo={therapistInfo}
                                    selectedFilters={selectedFilters}
                                />
                            </Typography>
                        </div>
                    </div>
                </div>

                {therapistInfo?.match_score && (
                    <div className='therapists_Mobile_list__item-percentage' >
                        <CircularProgressbarWithChildren
                            value={therapistInfo?.match_score}
                            strokeWidth={9}
                            styles={buildStyles({
                                strokeLinecap: 'butt',
                                pathColor: `#26ECB0`,
                                trailColor: '#D4F3EA'
                            })}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyItems: 'center',
                                alignItems: 'center'
                            }}>
                                <Typography
                                    variant={`size-16`}
                                    weight='black'
                                    className='percentage-label'>
                                    <div>{therapistInfo?.match_score}%</div>
                                </Typography>
                                <Typography
                                    weight='bold'
                                    color='color-4'
                                    variant={`size-10`}
                                >MATCH</Typography>
                            </div>
                        </CircularProgressbarWithChildren>
                    </div>
                )}

            </div>
            <div
                className={`d-flex mt-2 card-slot-container ${expandAvailability === index ? "custom-height-car" : ""
                    }`}
            >
                {statusLoading === true &&
                   statusLoadingElement === therapistInfo.id ? (
                     <div
                      className="d-flex justify-content-center pt-4"
                     style={{
                            width: "100%",
                                }}
                                >
                            <Spinner
                            animation="border"
                            role="status"
                            variant="dark"
                            className="d-flex justify-content-center"
                            />
                            </div>
                            ) : therapistInfo?.slots_data?.length ? (
                    <AvailableSlots
                        practiceTimeZone={practiceTimeZone}
                        availableSlots={therapistInfo.grouped_slot_data || {}}
                        bookAppointmentSlot={(slot) =>
                            statusLoading === false
                                ? bookAppointmentSlot(slot, therapistInfo)
                                : null
                        }
                        isFromMobile={true}
                    />
                ) : (
                    <div className="d-flex m-auto cursor-pointer" onClick={() => handleLaterSlot(therapistInfo)}>
                        <Typography
                            variant="size-14"
                            color="color-2"
                            weight="bold"
                            className="later_slot"
                        >
                            {`Next opening: ${moment(therapistInfo?.later_slot?.slot_start_date_time).format("ddd, MMM D, hh:mm A")}`}
                        </Typography>
                    </div>
                )}
            </div>
            {moreVisible.includes(therapistInfo.therapist_id) && (
                <div
                    className={`view-availability justify-content-center cursor-pointer mt-2 mb-3 ${cardExpand === index ? "d-none" : "d-flex"
                        }`}
                    onClick={() => handleAvailability(index)}
                >
                    <Typography variant="size-12" weight="bold">
                        View More Availability{" "}
                        <FontAwesomeIcon
                            icon={faArrowDownLong}
                            rotation={expandAvailability === index ? 180 : 0}
                        />
                    </Typography>
                </div>
            )}
        </div>
    );
}

export default TherapistMobileCard;
